<div *ngIf="hasFrancoConfig && contextOrder?.price?.seuilFranco > 0" class="dropdown header-element ctn-franco">

  <div [tooltip]="tooltipFrancoClassique" 
       class="tile tile-centered btn btn-link disabled-dropdown"
       *ngIf="contextService.isVitafrais() ? franco?.vitafraisIsFrancoActive : franco?.pronaturaIsFrancoActive"
       [ngClass]="{'is-disabled': shouldDisableClassic()}">

    <span class="tile-subtitle">{{ 'header.reachedClassicFranco' | translate }} &nbsp;</span>
    <span class="progress-bar" [ngClass]="{
      'progress-bar-orange': (contextService.isVitafrais() ? franco?.vitafraisFrancoPercentage : franco?.pronaturaFrancoPercentage) >= 80 
        && (contextService.isVitafrais() ?
       franco?.vitafraisFrancoPercentage : franco?.pronaturaFrancoPercentage) < 100, 
      'progress-bar-green': (contextService.isVitafrais() ? franco?.vitafraisFrancoPercentage : franco?.pronaturaFrancoPercentage) >= 100
    }">&nbsp;</span>
  </div>

  <div [tooltip]="tooltipFrancoUnique" 
       class="tile tile-centered btn btn-link disabled-dropdown" 
       *ngIf="isFrancoUnique"
       [ngClass]="{'is-disabled': shouldDisableUnique()}">

    <span *ngIf="franco.uniqueIsFrancoActive" class="tile-subtitle">{{ 'header.reachedCommonFranco' | translate }} &nbsp;</span>
    <span *ngIf="franco.isFrancoSaisonnier" class="tile-subtitle">{{ 'header.reachedSaisonnierFranco' | translate }} &nbsp;</span>

    <span class="progress-bar" [ngClass]="{
      'progress-bar-orange': (franco?.uniqueFrancoPercentage >= 80 && franco?.uniqueFrancoPercentage < 100), 
      'progress-bar-green': (franco?.uniqueFrancoPercentage >= 100)
    }">&nbsp;</span>
  </div>

</div>


<div *ngIf="showFeeAmount && shouldDisplayFees()" class="franco-fee-label">
  <span [innerHTML]="'header.francoAlert' | translate: {  'fee' : (getCurrentFee() | number:'1.2-2') }">
  </span>
</div>